<template>
  <a-card :title="'昨日数据统计' + today_dt">
    <a-space >
      <a-form layout="inline" :model="formSearch" style="margin: 10px auto;" >
        <a-form-item label="国家代码">
          <a-input placeholder="Region" v-model:value="formSearch.region" />
        </a-form-item>
        <a-form-item>
          <a-button
            :loading="loading"
            type="primary"
            html-type="submit"
            @click="load()"
            shape="circle"
          >
          <template #icon><SearchOutlined /></template>
          </a-button>
          
        </a-form-item>
      </a-form>
      <a-button
        :loading="loading"
        type="primary"
        @click="loadRegion('')"
      >全球</a-button>
      <a-button
        :loading="loading"
        type="primary"
        @click="loadRegion('CN')"
      >国内</a-button>
      <a-button
        :loading="loading"
        type="primary"
        @click="loadRegion('OVERSEA')"
      >海外</a-button>
    </a-space>
      <table class="stats-table">
        <legend>昨日整体数据</legend>
        <tr>
          <th >项目</th><th>数据</th><th>公式</th><th>说明</th>
        </tr>
        <tr>
          <td>用户新增</td><td>{{ stats_data.user_today_count }}</td><td></td><td></td>
        </tr>
        <tr>
          <td>会员新增：</td><td>{{ stats_data.vip_today_count }}</td><td></td><td>
            包括应用内购买会员、后台开通会员、终身会员等所有会员
          </td>
        </tr>
        <tr>
          <td>订单收入</td><td> {{ (stats_data.pay_today_amount.pay_amount / 100).toFixed(2) }}¥</td><td></td>
          <td>系统内订单收入，不包含后台开通会员、终身会员</td>
        </tr>
        <tr>
          <td>新用户付费金额</td>
          <td> {{ (stats_data.pay_user_today_amount.pay_amount / 100 ).toFixed(2) }}¥ </td>
          <td></td>
          <td>系统内订单收入，不包含后台开通会员、终身会员</td>
        </tr>
        <tr>
          <td>新用户人均付费金额</td>
          <td> {{ (stats_data.pay_user_today_amount.pay_amount / 100 / stats_data.user_today_count ).toFixed(2) }}¥ </td>
          <td>{{ (stats_data.pay_user_today_amount.pay_amount / 100).toFixed(2) }} /  {{stats_data.user_today_count }}</td>
          <td>系统内订单收入，不包含后台开通会员、终身会员</td>
        </tr>
        <tr>
          <td>人均付费金额</td>
          <td> {{ (stats_data.pay_today_amount.pay_amount / 100 / stats_data.user_today_count ).toFixed(2) }}¥ </td>
          <td>{{ (stats_data.pay_today_amount.pay_amount / 100).toFixed(2) }} / {{stats_data.user_today_count}}</td>
          <td>系统内订单收入，不包含后台开通会员、终身会员</td>
        </tr>
        <tr>
          <td>付费用户数</td>
          <td> {{ stats_data.pay_user_today_count }} </td>
          <td></td>
          <td>系统内订单收入，不包含后台开通会员、终身会员</td>
        </tr>
       
      </table>
      <table class="stats-table">
        <legend>昨日订单信息</legend>
        <tr>
          <th >支付方式</th><th>金额(¥)</th><th>数量</th>
        </tr>
        <tr>
          <td>Alipay</td>
          <td> 
            {{ stats_data.new_order_sum.alipay.pay_amount / 100 }}
          </td>
          <td>{{ stats_data.new_order_sum.alipay.total_count }}</td>
        </tr>
        <tr>
          <td>Wxpay</td>
          <td> 
            {{ stats_data.new_order_sum.wxpay.pay_amount / 100 }}
          </td>
          <td>{{ stats_data.new_order_sum.wxpay.total_count }}</td>
        </tr>
        <tr>
          <td>Apple</td>
          <td> 
             {{ stats_data.new_order_sum.apple.pay_amount / 100 }}
          </td>
          <td>{{ stats_data.new_order_sum.apple.total_count }}</td>
        </tr>
        <tr>
          <td>Google</td>
          <td> 
           {{ stats_data.new_order_sum.google.pay_amount / 100 }}
          </td>
          <td>{{ stats_data.new_order_sum.google.total_count }}</td>
        </tr>
      </table>
          
      <hr />
      <table class="stats-table">
        <legend>昨日分端数据</legend>
        <tr>
          <th >项目</th><th>iOS</th><th>Android</th><th>说明</th>
        </tr>
        <tr>
          <td >昨日新增用户</td><td>
            {{ stats_data.new_user_count.ios  }}
          </td><td>
            {{ stats_data.new_user_count.android  }}
          </td>
          <td> </td>
        </tr>
        <tr>
          <td >昨日新增用户会员开通</td><td>
            {{ stats_data.new_user_vip_count.ios  }}
            （开通率：{{ (stats_data.new_user_vip_count.ios / stats_data.new_user_count.ios * 100).toFixed(2) }}%）
          </td><td>
            {{ stats_data.new_user_vip_count.android  }}
            （开通率：{{ (stats_data.new_user_vip_count.android / stats_data.new_user_count.android * 100).toFixed(2) }}%）
          </td>
          <td>
            包括应用内购买会员、后台开通会员、终身会员等所有会员
          </td>
        </tr>
        <tr>
          <td >昨日会员开通</td><td>
            {{ stats_data.new_vip_count.ios  }}
           
          </td><td>
            {{ stats_data.new_vip_count.android  }}
          </td>
          <td>
            包括应用内购买会员、后台开通会员、终身会员等所有会员
          </td>
        </tr>
        <tr>
          <td >昨日新增用户付费金额</td><td>
            {{ (stats_data.new_user_payment_amount.ios / 100).toFixed(2)  }}¥
            （人均付费金额： {{ (stats_data.new_user_payment_amount.ios / 100 / stats_data.new_user_count.ios).toFixed(2) }}¥）
          </td><td>
            {{ (stats_data.new_user_payment_amount.android / 100).toFixed(2)  }}¥
            （人均付费金额： {{ (stats_data.new_user_payment_amount.android / 100 / stats_data.new_user_count.android).toFixed(2) }}¥）
          </td>
          <td>
            系统内订单收入，不包含后台开通会员、终身会员
          </td>
        </tr>
        <tr>
          <td >7日内新增用户数</td><td>
            {{stats_data.new_user_7d_count.ios  }}
          </td><td>
            {{stats_data.new_user_7d_count.android  }}
          </td>
          <td></td>
        </tr>
        <tr>
          <td >7日内新增用户付费数</td><td>
            {{stats_data.new_user_payment_7d_count.ios  }}
            (付费率: {{ (stats_data.new_user_payment_7d_count.ios / stats_data.new_user_7d_count.ios * 100).toFixed(2) }}%)
          </td><td>
            {{stats_data.new_user_payment_7d_count.android  }}
            (付费率: {{ (stats_data.new_user_payment_7d_count.android / stats_data.new_user_7d_count.android * 100).toFixed(2) }}%)
          </td>
          <td>
            系统内订单收入，不包含后台开通会员、终身会员
          </td>
        </tr>
        <tr>
          <td >30日内新增用户数</td><td>
            {{stats_data.new_user_30d_count.ios  }}
          </td><td>
            {{stats_data.new_user_30d_count.android  }}
          </td>
          <td></td>
        </tr>
        <tr>
          <td >30日内新增用户付费数</td><td>
            {{stats_data.new_user_payment_30d_count.ios  }}
            (付费率: {{ (stats_data.new_user_payment_30d_count.ios / stats_data.new_user_30d_count.ios * 100).toFixed(2) }}%)
          </td><td>
            {{stats_data.new_user_payment_30d_count.android  }}
            (付费率: {{ (stats_data.new_user_payment_30d_count.android / stats_data.new_user_30d_count.android * 100).toFixed(2) }}%)
          </td>
          <td>
            系统内订单收入，不包含后台开通会员、终身会员
          </td>
        </tr>
      </table>
  </a-card>
</template>
<script>
import { defineComponent} from 'vue'
import { SearchOutlined } from '@ant-design/icons-vue';
import request from '@/utils/request'
const TaskStatus = {
  0: "排队中",
  1: "创作中",
  2: "创作完成",
  3: "创作失败",
}

export default defineComponent({
  components: {
    // UserEditor,
    SearchOutlined
  },
  data(){
    const today = new Date();
    today.setDate(today.getDate() - 1);
    return {
      today_dt: today.toLocaleDateString(),
      TaskStatus,
      loading: false,
      dataSource: [],
      pagination: {
        total: 1,
        current: 1,
        pageSize: 20,
        'show-size-changer': true,
        pageSizeOptions: ['20', '50', '100']
      },
      noticeMessage: '',
      stats_data:{
        "new_order_sum": {
          "alipay": {},
          "apple": {},
          "wxpay": {},
          "google": {},
        },
        "new_user_30d_count": {
          ios: 0,
          android: 0
        },
        "new_user_7d_count": {
          ios: 0,
          android: 0
        },
        "new_user_payment_30d_count": {
          ios: 0,
          android: 0
        },
        "new_user_payment_7d_count": {
          ios: 0,
          android: 0
        },
        "new_user_count": {
          ios: 0,
          android: 0
        },
        "new_user_vip_count": {
          ios: 0,
          android: 0
        },
        "new_vip_count": {
          ios: 0,
          android: 0
        },
        "new_user_payment_amount": {
          ios: 0,
          android: 0
        },
        "pay_today_amount": {
            "pay_amount": 0,
            "total_amount": 0,
            "discount_amount": 0
        },
        "pay_user_today_amount": {
            "pay_amount": 0,
            "total_amount": 0,
            "discount_amount": 0
        },
        "pay_user_today_count": 0,
        "vip_today_count": 0,
      },
       formSearch: {
        region: '',
      },

      uploadLoading: false,
    }
  },
  mounted(){
    this.load()
  },
  methods: {
    loadRegion(region) {
      this.formSearch.region = region
      this.load()
    },
    async load () {
      this.loading = true
      
      const rspYesterday = await request.get('/api/stats/yesterday', {
        ...this.formSearch,
      })
      for(let k in rspYesterday.data) {
        this.stats_data[k] = rspYesterday.data[k]
      }
      const rspByClient = await request.get('/api/stats/yesterday/by_client', {
        ...this.formSearch,
      })
      this.loading = false
      for(let k in rspByClient.data) {
        this.stats_data[k] = rspByClient.data[k]
      }
    },
  
  },
  setup(props, context) {
   
    return {
      uploadInput: null,
    };
  },
})
</script>

<style scoped>
.ant-table-striped :deep(.table-striped) td {
  background-color: #fafafa;
}


</style>